// Tipos de documento del contrato de prestación de servicios (lista fija).
// Debe coincidir con el enum del backend (microservice-users
// driver-service-contracts/constants/document-types.ts). La etiqueta se traduce
// vía i18n (la clave en español ES el texto base).
export const CONTRACT_DOCUMENT_TYPES = [
  { key: "contrato", label: "Contrato" },
  { key: "anexo_economico", label: "Anexo económico" },
  { key: "anexo_protocolo_atencion", label: "Anexo de protocolo de atención" },
  { key: "anexo_duracion", label: "Anexo de duración" },
  { key: "anexo_penalidades", label: "Anexo de penalidades" },
  { key: "anexo_incentivos", label: "Anexo de incentivos" },
  {
    key: "manual_procedimientos_externos",
    label: "Manual de procedimientos externos",
  },
];

export const documentTypeLabel = (key) =>
  CONTRACT_DOCUMENT_TYPES.find((d) => d.key === key)?.label ?? key;
